import { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';

import Text from 'components/common/Text';
import { BasketContext, PickYourMealsContext } from 'components/signUpFunnel/Contexts';
import { basketCutoffLocalTimeNoZone, thankYouBasketCutoffDate } from 'helpers/timeFormat';
import styles from 'styles/components/signUpFunnel/thankYou/CutOffDateAndTime';

const CutOffDateAndTime = ({ textStyles }) => {
  const { basket } = useContext(BasketContext);
  const { isPickYourMeals } = useContext(PickYourMealsContext);
  const textSize = isPickYourMeals ? 'text' : 'bp1:textMd textSm';

  return (
    <>
      <Text
        brandStylesOverrides="font-medium text-secondary"
        className={`${textSize} mb-1 ${textStyles}`}
      >
        {isPickYourMeals ? 'Make changes by' : 'Pick your meals by'}{' '}
        {basket ? (
          thankYouBasketCutoffDate(basket.editingCutoff)
        ) : (
          <Skeleton className={styles.skeleton150} />
        )}{' '}
        at{' '}
        {basket ? (
          basketCutoffLocalTimeNoZone(basket.editingCutoff)
        ) : (
          <Skeleton className={styles.skeleton100} />
        )}
      </Text>
    </>
  );
};

CutOffDateAndTime.propTypes = {
  textStyles: PropTypes.string,
};

export default CutOffDateAndTime;
